module.exports = __webpack_public_path__ + "images/landing/video-previews/Fashion_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Fashion_2x.jpg
// module id = FXBL
// module chunks = 1